import { useApiClient } from '../../hooks/useApiClient';
import { ApiResponse } from '../../types/ApiResponse.type';
import { GetTeamsQueryParams } from '../../types/QueryParams.type';
import { Team } from '../../types/Team/Team.type';
import { TeamCreate } from '../../types/Team/TeamCreate.type';
import { TeamUpdate } from '../../types/Team/TeamUpdate.type';
import { buildQueryString } from '../../utils/buildQueryString';

export const useTeamApi = () => {
  const apiClient = useApiClient();

  return {
    getTeams: (params: GetTeamsQueryParams): Promise<ApiResponse<Team[]>> => {
      const queryString = buildQueryString(params);

      return apiClient(`/teams/${queryString}`);
    },

    createTeam: (teamData: TeamCreate): Promise<Team> => {
      return apiClient('/teams/', {
        method: 'POST',
        body: JSON.stringify(teamData),
      });
    },

    updateTeam: (teamId: number, updateData: TeamUpdate): Promise<Team> => {
      return apiClient(`/teams/${teamId}`, {
        method: 'PATCH',
        body: JSON.stringify(updateData),
      });
    },

    deleteTeam: (teamId: number): Promise<void> => {
      return apiClient(`/teams/${teamId}`, {
        method: 'DELETE',
      });
    },
  };
};
